module.exports = __webpack_public_path__ + "img/baseline-pause-24px (1).cd7da876.svg";